import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST } from '../SQL';
import { function_VEN_DocsVenta_Generar_JSON } from './DocsVenta/VEN_DocsVenta_Cabecera';
import { function_VEN_Recibos_Generar_JSON } from './Recibos/VEN_Recibos_Cabecera';

export const function_VEN_OperacionesDeVenta = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_OperacionesDeVenta"

    try {
        const resulData = await llamadaAPI_GET("VEN_OperacionesDeVenta/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_DocsVenta_Recibo_Insertar = async (DocVentaRecibo, BajaStockSinImportarDefinicionDeArticulo) => {
    const NombreFuncion = "function_VEN_DocsVenta_Recibo_Insertar";

    try {
        const docVentaResult = await llamadaAPI_POST("VEN_DocsVenta_Recibo/InsertarCompleto/" +
            BajaStockSinImportarDefinicionDeArticulo,
            DocVentaRecibo);
        return docVentaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_DocsVenta_Recibo_Generar_JSON = async (IdDocVenta, IdTipoDocVenta, Fecha, IdCliente, NumeroFantasia,
    CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, ImporteBonificacionesDocVenta, ImporteRecargosDocVenta, 
    Concepto, Observaciones, IdDocVentaReferente, FEFecha, 
    CodigoCondicionVenta, FechaVencimiento, CodigoMonedaReferente, Terminal,
    Turno, IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoResumenDePagoProveedorDelivery, 
    CodigoMesa, CantidadComensales, IdProfesionalMozo,
    FechaAperturaDocumentoAbierto, FechaCierreDocumentoAbierto, IdUsuarioCreador,
    ColeccionDetalles, ColeccionImpuestosDocVenta, ColeccionImputacionesContableDocVenta, ColeccionImputacionesCosteo, ColeccionProfesionalesACargo,
    IdRecibo, NumeroFantasiaRecibo,
    CodigoPuntoFiscalRecibo, NumeroRecibo, ImporteBonificacionesRecibo, ImporteRecargosRecibo, 
    ColeccionImputacionesFinanciera, ColeccionImpuestosRecibo, ColeccionImputacionesContableRecibo, 
    ColeccionRelacionesDocsVentaRecibos, ColeccionImputacionesFinancieraRecargosBonificaciones) => {
    const NombreFuncion = "function_VEN_DocsVenta_Recibo_Generar_JSON";

    try {
        const DocVenta = await function_VEN_DocsVenta_Generar_JSON(IdDocVenta, Turno, IdUsuarioCreador, 
            IdTipoDocVenta, IdCliente, Fecha, FEFecha, FechaVencimiento, 
            NumeroFantasia, CodigoPuntoFiscal, Numero, CodigoMoneda, Cotizacion, CodigoMonedaReferente, 
            ImporteBonificacionesDocVenta, ImporteRecargosDocVenta, Concepto, Observaciones, IdDocVentaReferente,
            CodigoCondicionVenta, IdProveedorDelivery, CodigoOperacionProveedorDelivery, CodigoResumenDePagoProveedorDelivery, 
            CodigoMesa, CantidadComensales, IdProfesionalMozo,
            FechaAperturaDocumentoAbierto, FechaCierreDocumentoAbierto, 
            ColeccionDetalles, ColeccionImpuestosDocVenta, ColeccionImputacionesContableDocVenta, ColeccionImputacionesCosteo, ColeccionProfesionalesACargo)

        const Recibo = await function_VEN_Recibos_Generar_JSON(IdRecibo, 
            Fecha, IdCliente, NumeroFantasiaRecibo, CodigoPuntoFiscalRecibo, NumeroRecibo, CodigoMoneda, Cotizacion,
            Observaciones, ImporteBonificacionesRecibo, 
            ImporteRecargosRecibo, ColeccionImputacionesFinanciera, ColeccionImpuestosRecibo, ColeccionImputacionesContableRecibo, 
            ColeccionRelacionesDocsVentaRecibos, ColeccionImputacionesFinancieraRecargosBonificaciones)

        const JSON = {
            DocVenta: {}, Detalles: [],
            ImpuestosDocVenta: [], ImputacionesContableDocVenta: [], ImputacionesCosteo: [], ProfesionalesACargo: [],
            Recibo: {}, ImputacionesFinanciera: [], ImpuestosRecibo: [], ImputacionesContableRecibo: [],
            RelacionesDocsVentaRecibos: [], ImputacionesFinancieraRecargosBonificaciones: []
        };

        for (const key in DocVenta) {
            if (key === 'Impuestos') {
                JSON.ImpuestosDocVenta = DocVenta[key];
            } else if (key === 'ImputacionesContable') {
                JSON.ImputacionesContableDocVenta = DocVenta[key];
            } else if (Array.isArray(DocVenta[key])) {
                // Si es un array, mantenerlo al mismo nivel
                JSON[key] = DocVenta[key];
            } else {
                // Si no es un array, agregarlo dentro de DocVenta
                JSON.DocVenta[key] = DocVenta[key];
            }
        }
        
        for (const key in Recibo) {
            if (key === 'Impuestos') {
                JSON.ImpuestosRecibo = Recibo[key];
            } else if (key === 'ImputacionesContable') {
                JSON.ImputacionesContableRecibo = Recibo[key];
            } else if (Array.isArray(Recibo[key])) {
                // Si es un array, mantenerlo al mismo nivel
                JSON[key] = Recibo[key];
            } else {
                // Si no es un array, agregarlo dentro de Recibo
                JSON.Recibo[key] = Recibo[key];
            }
        }

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};